import classNames from 'classnames';
import React from 'react';
import * as styles from './Banner.module.scss';
import Button from '../components/Button';
import SVGIcon from '../components/SVGIcon';
import clearIcon from '../icons/non-prefilled/16x16/clear.svg';

interface BannerProps {
  children: React.ReactNode;
  onDismiss?: () => void;
  variant: 'inverted' | 'warning' | 'danger';
}

const Banner = ({ children, onDismiss, variant }: BannerProps) => (
  <div className={classNames(styles.container, styles[variant])}>
    <div className={styles.message}>{children}</div>
    {onDismiss && (
      <div className={styles.dismissContainer}>
        <Button block onClick={onDismiss}>
          <SVGIcon size={14}>{clearIcon}</SVGIcon>
        </Button>
      </div>
    )}
  </div>
);

export default Banner;
